import kformBuilderUtils from '../../utils/kform-builder.utils';

const KformBuilderOptionKeyController = /* @ngInject */ (/** @type {any} */ $scope) => {
	kformBuilderUtils.uniquify($scope.form, $scope.component);

	$scope.onBlur = () => {
		$scope.component.lockKey = true;

		// If they try to input an empty key, refill it with default and let uniquify make it unique.
		if (!$scope.component.key && $scope.formComponents[$scope.component.type].settings.key) {
			$scope.component.key = $scope.formComponents[$scope.component.type].settings.key;
			$scope.component.lockKey = false; // Also unlock key
			kformBuilderUtils.uniquify($scope.form, $scope.component);
		}
	};

	$scope.shouldWarnAboutEmbedding = () => {
		if (!$scope.component || !$scope.component.key) {
			return false;
		}
		return !$scope.component.source && $scope.component.key.includes('.');
	};
};

export default KformBuilderOptionKeyController;
